import { DependenciesInjection } from "app/di/DependencyInjection";
import { AirTimeRegistrationImpl } from "features/airTimeRegistration/data/AirTimeRegistrationImpl";
import { AirTimeRegistrationViewModel } from "features/airTimeRegistration/presentation/viewModel/AirTimeRegistrationViewModel";
import { IAirTimeRegistrationRepository } from "../domain/repositories/IAirTimeRegistrationRepository";
import { AirTimeRegistrationUseCase } from "../domain/useCases/AirTimeRegistrationUseCase";
import { AirTimeRegistrationToken } from "./AirTimeRegistrationToken";

export class AirTimeRegistrationInjection {
  static initInjections(): void {
    DependenciesInjection.register<IAirTimeRegistrationRepository>(
      AirTimeRegistrationToken.IAirTimeRegistrationRepository,
      AirTimeRegistrationImpl,
      "otherRepo",
    );
    DependenciesInjection.register<AirTimeRegistrationUseCase>(
      AirTimeRegistrationToken.AirTimeRegistrationUseCase,
      AirTimeRegistrationUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<AirTimeRegistrationViewModel>(
      AirTimeRegistrationToken.AirTimeRegistrationViewModel,
      AirTimeRegistrationViewModel,
      "viewModel",
    );
  }

  static getAirTimeRegistrationRepo(): IAirTimeRegistrationRepository {
    return DependenciesInjection.getRepo<IAirTimeRegistrationRepository>(
      AirTimeRegistrationToken.IAirTimeRegistrationRepository,
    );
  }

  static getAirTimeRegistrationUseCase(): AirTimeRegistrationUseCase {
    return DependenciesInjection.getRepo<AirTimeRegistrationUseCase>(
      AirTimeRegistrationToken.AirTimeRegistrationUseCase,
    );
  }
}
